import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import { bufferTimeBetweenPermitsRuleMessages } from "./rules/buffer-time-between-permits/buffer-time-between-permits-messages";
import { codeRuleMessages } from "./rules/code-rule/code-rule-messages";
import { creationDateIsWithinAvailabilityWindowRuleMessages } from "./rules/creation-date-within-availability-window/creation-date-within-availability-window-messages";
import { disableCancelPermitRuleMessages } from "./rules/disable-cancel-permit/disable-cancel-permit-messages";
import { disableEditPermitRuleMessages } from "./rules/disable-edit-permit/disable-edit-permit-messages";
import { durationMaximumRuleMessages } from "./rules/duration-maximum/duration-maximum-messages";
import { durationMinimumRuleMessages } from "./rules/duration-minimum/duration-minimum-messages";
import { durationSetRuleMessages } from "./rules/duration-set/duration-set-messages";
import { emailIsRequiredRuleMessages } from "./rules/email-is-required/email-is-required-messages";
import { expiresInNumberOfDaysRuleMessages } from "./rules/expires-in-number-of-days/expires-in-number-of-days-messages";
import { expiresOnDayOfWeekRuleMessages } from "./rules/expires-on-day-of-week/expires-on-day-of-week-messages";
import { expiresSameDayRuleMessages } from "./rules/expires-same-day/expires-same-day-messages";
import { expiryDateAfterDateRuleMessages } from "./rules/expiry-date-after-date/expiry-date-after-date-messages";
import { expiryDateBeforeDateRuleMessages } from "./rules/expiry-date-before-date/expiry-date-before-date-messages";
import { expiryDateRuleMessages } from "./rules/expiry-date/expiry-date-messages";
import { expiryMustBeOnStartDayRuleMessages } from "./rules/expiry-must-be-on-start-day/expiry-must-be-on-start-day-messages";
import { expiryTimeAfterTimeRuleMessages } from "./rules/expiry-time-after-time/expiry-time-after-time-messages";
import { expiryTimeBeforeTimeRuleMessages } from "./rules/expiry-time-before-time/expiry-time-before-time-messages";
import { expiryTimeRuleMessages } from "./rules/expiry-time/expiry-time-messages";
import { globalLocationCapacityRuleMessages } from "./rules/global-location-capacity/global-location-capacity-messages";
import { intervalCountAtLeastOneRuleMessages } from "./rules/interval-count-at-least-one/interval-count-at-least-one-messages";
import { isNotOnLocationDenyListRuleMessages } from "./rules/is-not-on-location-deny-list/is-not-on-location-deny-list-messages";
import { isNotOnTenantDenyListRuleMessages } from "./rules/is-not-on-tenant-deny-list/is-not-on-tenant-deny-list-messages";
import { locationChoiceRuleMessages } from "./rules/location-choice/location-choice-messages";
import { maxPermitsPerLocationRuleMessages } from "./rules/max-permits-per-location/max-permits-per-location-messages";
import { maxPermitsPerPermitTypeRuleMessages } from "./rules/max-permits-per-permit-type/max-permits-per-permit-type-messages";
import { maxPermitsPerTenantRuleMessages } from "./rules/max-permits-per-tenant/max-permits-per-tenant-messages";
import { maxSelfServiceVehicleChangesRuleMessages } from "./rules/max-self-service-vehicle-changes/max-self-service-vehicle-changes-messages";
import { maxTenantPlateLimitRuleMessages } from "./rules/max-tenant-plate-limit/max-tenant-plate-limit-messages";
import { maxTimePerCodeInPeriodRuleMessages } from "./rules/max-time-per-code-in-period/max-time-per-code-in-period-messages";
import { maxTimePerVehicleInPeriodRuleMessages } from "./rules/max-time-per-vehicle-in-period/max-time-per-vehicle-in-period-messages";
import { maxTotalPermitsInPeriodRuleMessages } from "./rules/max-total-permits-in-period/max-total-permits-in-period-messages";
import { maxVehicleUsageInPeriodRuleMessages } from "./rules/max-vehicle-usage-in-period/max-vehicle-usage-in-period-messages";
import { maxVehiclesOnPermitRuleMessages } from "./rules/max-vehicles-on-permit/max-vehicles-on-permit-messages";
import { permitTypeOverrideRuleMessages } from "./rules/permit-type-override/permit-type-override-messages";
import { preflightDateTimeParseRuleMessages } from "./rules/preflight-date-time-parse/preflight-date-time-parse-messages";
import { recurringAvailabilityWindowRuleMessages } from "./rules/recurring-availability-window/recurring-availability-window-messages";
import { secondRoundingRuleMessages } from "./rules/second-rounding/second-rounding-messages";
import { smsIsRequiredRuleMessages } from "./rules/sms-is-required/sms-is-required-messages";
import { startBeforeExpiryRuleMessages } from "./rules/start-before-expiry/start-before-expiry-messages";
import { startDateAfterDateRuleMessages } from "./rules/start-date-after-date/start-date-after-date-messages";
import { startDateBeforeDateRuleMessages } from "./rules/start-date-before-date/start-date-before-date-messages";
import { startDateIsNowRuleMessages } from "./rules/start-date-is-now/start-date-is-now-messages";
import { startDateRuleMessages } from "./rules/start-date/start-date-messages";
import { startOnDayOfWeekRuleMessages } from "./rules/start-on-day-of-week/start-on-day-of-week-messages";
import { startTimeAfterTimeRuleMessages } from "./rules/start-time-after-time/start-time-after-time-messages";
import { startTimeBeforeTimeRuleMessages } from "./rules/start-time-before-time/start-time-before-time-messages";
import { startTimeIsNotInPastRuleMessages } from "./rules/start-time-is-not-in-past/start-time-is-not-in-past-messages";
import { startTimeIsNowRuleMessages } from "./rules/start-time-is-now/start-time-is-now-messages";
import { startTimeRuleMessages } from "./rules/start-time/start-time-messages";
import { trimExpiredIntervalsRuleMessages } from "./rules/trim-expired-intervals/trim-expired-intervals-messages";
import { truncateSetDurationToFixedExpiryTimeRuleMessages } from "./rules/truncate-set-duration-to-fixed-expiry-time/truncate-set-duration-to-fixed-expiry-time-messages";
import { uniqueVehiclesOnSettingRuleMessages } from "./rules/unique-vehicles-on-setting/unique-vehicles-on-setting-messages";
import { vehicleCountAtLeastOneRuleMessages } from "./rules/vehicle-count-at-least-one/vehicle-count-at-least-one-messages";
import { vehiclePlateCharacterLengthRuleMessages } from "./rules/vehicle-plate-character-length/vehicle-plate-character-length-messages";
import { vehicleStateMatchRuleMessages } from "./rules/vehicle-state-match/vehicle-state-match-messages";
import { vehiclesAreUniqueRuleMessages } from "./rules/vehicles-are-unique/vehicles-are-unique-messages";

export type RuleMessageEntry = {
	name?: MessageDescriptor;
	description?: MessageDescriptor;
	errors?: Record<string, MessageDescriptor>;
};

export const ruleErrorTitle = msg({ message: "Rule Error" });

export const ruleMessages = {
	BufferTimeBetweenPermitsRule: bufferTimeBetweenPermitsRuleMessages,
	CodeRule: codeRuleMessages,
	CreationDateIsWithinAvailabilityWindowRule: creationDateIsWithinAvailabilityWindowRuleMessages,
	DisableCancelPermitRule: disableCancelPermitRuleMessages,
	DisableEditPermitRule: disableEditPermitRuleMessages,
	DurationMaximumRule: durationMaximumRuleMessages,
	DurationMinimumRule: durationMinimumRuleMessages,
	DurationSetRule: durationSetRuleMessages,
	EmailIsRequiredRule: emailIsRequiredRuleMessages,
	ExpiresInNumberOfDaysRule: expiresInNumberOfDaysRuleMessages,
	ExpiresOnDayOfWeekRule: expiresOnDayOfWeekRuleMessages,
	ExpiresSameDayRule: expiresSameDayRuleMessages,
	ExpiryDateAfterDateRule: expiryDateAfterDateRuleMessages,
	ExpiryDateBeforeDateRule: expiryDateBeforeDateRuleMessages,
	ExpiryDateRule: expiryDateRuleMessages,
	ExpiryMustBeOnStartDayRule: expiryMustBeOnStartDayRuleMessages,
	ExpiryTimeAfterTimeRule: expiryTimeAfterTimeRuleMessages,
	ExpiryTimeBeforeTimeRule: expiryTimeBeforeTimeRuleMessages,
	ExpiryTimeRule: expiryTimeRuleMessages,
	IntervalCountAtLeastOneRule: intervalCountAtLeastOneRuleMessages,
	IsNotOnLocationDenyListRule: isNotOnLocationDenyListRuleMessages,
	IsNotOnTenantDenyListRule: isNotOnTenantDenyListRuleMessages,
	LocationChoiceRule: locationChoiceRuleMessages,
	MaxTotalPermitsInPeriodRule: maxTotalPermitsInPeriodRuleMessages,
	GlobalLocationCapacityRule: globalLocationCapacityRuleMessages,
	MaxPermitsPerLocationRule: maxPermitsPerLocationRuleMessages,
	MaxPermitsPerPermitTypeRule: maxPermitsPerPermitTypeRuleMessages,
	MaxPermitsPerTenantRule: maxPermitsPerTenantRuleMessages,
	MaxSelfServiceVehicleChangesRule: maxSelfServiceVehicleChangesRuleMessages,
	MaxTenantPlateLimitRule: maxTenantPlateLimitRuleMessages,
	MaxTimePerCodeInPeriodRule: maxTimePerCodeInPeriodRuleMessages,
	MaxTimePerVehicleInPeriodRule: maxTimePerVehicleInPeriodRuleMessages,
	MaxVehiclesOnPermitRule: maxVehiclesOnPermitRuleMessages,
	MaxVehicleUsageInPeriodRule: maxVehicleUsageInPeriodRuleMessages,
	PermitTypeOverrideRule: permitTypeOverrideRuleMessages,
	PreflightDateTimeParseRule: preflightDateTimeParseRuleMessages,
	RecurringAvailabilityWindowRule: recurringAvailabilityWindowRuleMessages,
	SecondRoundingRule: secondRoundingRuleMessages,
	SmsIsRequiredRule: smsIsRequiredRuleMessages,
	StartBeforeExpiryRule: startBeforeExpiryRuleMessages,
	StartDateAfterDateRule: startDateAfterDateRuleMessages,
	StartDateBeforeDateRule: startDateBeforeDateRuleMessages,
	StartDateIsNowRule: startDateIsNowRuleMessages,
	StartDateRule: startDateRuleMessages,
	StartOnDayOfWeekRule: startOnDayOfWeekRuleMessages,
	StartTimeAfterTimeRule: startTimeAfterTimeRuleMessages,
	StartTimeBeforeTimeRule: startTimeBeforeTimeRuleMessages,
	StartTimeIsNotInPastRule: startTimeIsNotInPastRuleMessages,
	StartTimeIsNowRule: startTimeIsNowRuleMessages,
	StartTimeRule: startTimeRuleMessages,
	TrimExpiredIntervalsRule: trimExpiredIntervalsRuleMessages,
	TruncateSetDurationToFixedExpiryTimeRule: truncateSetDurationToFixedExpiryTimeRuleMessages,
	UniqueVehiclesOnSettingRule: uniqueVehiclesOnSettingRuleMessages,
	VehicleCountAtLeastOneRule: vehicleCountAtLeastOneRuleMessages,
	VehiclePlateCharacterLengthRule: vehiclePlateCharacterLengthRuleMessages,
	VehiclesAreUniqueRule: vehiclesAreUniqueRuleMessages,
	VehicleStateMatchRule: vehicleStateMatchRuleMessages,
} satisfies Record<string, RuleMessageEntry>;

const ruleMessageEntries = new Map<string, RuleMessageEntry>(Object.entries(ruleMessages));

export const getRuleErrorDescriptor = (rule: string, errorType: string): MessageDescriptor | undefined =>
	ruleMessageEntries.get(rule)?.errors?.[errorType];

export const getRuleName = (rule: string): MessageDescriptor | undefined => ruleMessageEntries.get(rule)?.name;
